import React from 'react';
import { BaseField } from 'react/components/fields';
import PropTypes from 'prop-types';

const renderFieldContent = ({ id, input, disabled }) => (
  <textarea id={id} {...input} disabled={disabled}>
    { input.value }
  </textarea>
);

const TextAreaField = (props) => (
  <BaseField fieldClassName="textAreaField" renderFieldContent={renderFieldContent} {...props} />
);

renderFieldContent.propTypes = {
  id: PropTypes.string.isRequired,
  input: PropTypes.object.isRequired,
  disabled: PropTypes.bool
};

renderFieldContent.defaultProps = {
  disabled: false
};

export default TextAreaField;
